import './_product-headline.scss';

export default () => {};
